
export default "/assets/clock-micro.83f1b268.svg"